<div class="business-hours-container">
  <div class="row no-gutters text-center" *ngFor="let time of businessHours">
    <div class="col align-self-center font-weight-medium pr-2">{{ time.dayOfTheWeek }}</div>
    <hr class="vertical" />
    <div class="col align-self-center pl-2">{{ time.timeOfDay }}</div>
  </div>
</div>
